const webSocketActionEnum = {
  PENDING: "pending",
  START: "start",
  END: "end",
};

export default webSocketActionEnum;
